import { useDebounceFn } from '@vueuse/core'
import { isAgentBot } from '~/shared/utils/isAgentBot'

export default defineNuxtRouteMiddleware(async (to) => {
  const path = to.path.startsWith('/') ? to.path.slice(1) : to.path

  const utmStore = useUTMStore()
  const { setUtmState } = utmStore

  // Extract UTM parameters from the query string
  const utm_source =
    to.query?.utm_source?.toString() || utmStore.utmState?.utm_source
  const utm_medium = to.query?.utm_medium?.toString()
  const utm_content = to.query?.utm_content?.toString()
  const utm_campaign = to.query?.utm_campaign?.toString()

  // Fallback Logic for UTM Source and Medium
  const referrer = useRequestHeader('referer')
  const userAgent = useRequestHeader('user-agent')

  const isBotRequest = isAgentBot(userAgent)

  if (isBotRequest) {
    // Skip processing for known bot user agents
    return
  }

  // Fetch the utm data
  if (import.meta.server) {
    const newContent = await $fetch('/intl-api/utm-slug', {
      method: 'POST',
      body: {
        path,
        referrer: utm_source ? undefined : referrer,
        utm_source,
        utm_medium,
        utm_content,
        utm_campaign
      }
    }).catch(() => ({}))

    // Set the UTM state with the fetched content, ensuring we don't overwrite existing values with undefined
    setUtmState(newContent || {})
  }

  // Only run on client side
  if (import.meta.client) {
    if (utm_medium) {
      setUtmState({
        ...utmStore.utmState,
        utm_medium
      })
    } else {
      useDebounceFn(async () => {
        try {
          const utmMedium = await $fetch<{
            utm_medium?: string
          }>('/intl-api/utm-medium', {
            method: 'POST',
            body: {
              path: path
            }
          })

          if (utmMedium?.utm_medium) {
            setUtmState({
              ...utmStore.utmState,
              utm_medium: utmMedium.utm_medium
            })
          }
        } catch (error) {
          console.warn('Failed to fetch UTM medium:', error)
        }
      }, 300)()
    }
  }
})
